// Module
var code = "<div class=\"view-account row\"> <div class=\"col-xs-3\"> <account-menu></account-menu> </div> <div class=\"col-xs-9\" ng-transclude=\"body\"></div> </div> ";
// Exports
export default code;